export const MENU_WIDTH = 240;

export const bold = { fontWeight: 'bold' };

export const black = { color: '#000' };
export const blackMedium = { color: 'rgba(0, 0, 0, 0.5)' };
export const blackHigh = { color: '#212121' };
export const success = {color:'#00B28A'};
export const caution = {color: '#DF9641'};

export const blackOutline = { color: 'rgba(0,0,0,0.12)' };

export const secondary = { color:'#2298DA' };
export const secondaryOutline = { color: 'rgba(34, 152, 218, 0.2)' };

export const h5 = {
    fontFamily: 'Inter',
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '30px',
};

export const h6 = {
    fontFamily: 'Inter',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: '24px',
};

export const subTitle1 = {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: 16,
    lineHeight: '24px',
};

export const subTitle2 = {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: '24px',
};

export const body2 = {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: '20px',
};

export const overline = {
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: 11,
    lineHeight: '16px',
};

export const caption = {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: 13,
    lineHeight: '16px',
};

export const button = {
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: 14,
    lineHeight: '24px',
};

export const vertCenterAbs = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
};
export const horiCenterAbs = {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
};

export const centerAbs = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translateY(-50%) translateX(-50%)'
};

export const columnCenter = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

export const rowCenter = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};

export const highlight = {
    color:'#2298da',
    textDecoration:'underline'
};